import { render } from "./ClassroomReceipt.vue?vue&type=template&id=78af2582&scoped=true"
import script from "./ClassroomReceipt.vue?vue&type=script&lang=js"
export * from "./ClassroomReceipt.vue?vue&type=script&lang=js"

import "./ClassroomReceipt.vue?vue&type=style&index=0&id=78af2582&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78af2582"]])

export default __exports__